export const FOOTER_TEST_IDS = {
  root: 'footer',
  footerContainer: 'footer-container',
  copyright: 'copyright',
  terms: 'terms',
  privacy: 'privacy',
  trademark: 'trademark',
  other: 'other',
  footerText: 'footer-text',
};
